module.exports = __webpack_public_path__ + "static/media/inclusivePanel.49ad050d.scss";


//////////////////
// WEBPACK FOOTER
// ./src/components/inclusive/inclusivePanel.scss
// module id = ./src/components/inclusive/inclusivePanel.scss
// module chunks = 0